import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    itemContainer: {
      width: '100%',
      margin: 'auto',
      '& .MuiFilledInput-root': {
        backgroundColor: 'unset',
      },
      '& .MuiInputLabel-root': {
        color: theme.palette.primary.dark,
        fontWeight: '600 !important',
      },
    },
    emailIllustrationContainer: {
      marginTop: theme.spacing(-2),
    },
    textAlignCenter: {
      textAlign: 'center',
    },
    subTitle: {
      marginTop: '15px',
      fontWeight: 500,
    },
    noMargin: {
      margin: 0,
    },
  }),
  {index: 1},
);

export default useStyles;
